export const GET_GEOFENCE_TEMPLATES = "GET_GEOFENCE_TEMPLATES";